



































import { Component, Vue } from 'vue-property-decorator'
import { NoCache } from '@/decorators'
import { Action, Getter } from 'vuex-class'
import { Receipt } from '@/services/models'

import { formatters } from '@/helpers/components-utils'

import PageTitle from '@/components/PageTitle.vue'
import EditReceiptModal from '@/components/EditReceiptModal.vue'
import { sortBy } from 'lodash'

@Component({
  components: {
    PageTitle,
    EditReceiptModal,
  },
})
export default class Receipts extends Vue {

  @Getter('firestore/receipts')
  private items!: Receipt[]

  // private get itemsByCode(): Receipt[] {
  //   return sortBy(this.items, 'code')
  // }

  @Action('firestore/fetchReceipts')
  private fetchReceipts!: () => Promise<Receipt[]>

  @Action('firestore/deleteReceipt')
  private deleteReceipt!: (receiptId: string) => Promise<void>

  @NoCache
  public get editingModal(): EditReceiptModal {
    return this.$refs.editingModal as EditReceiptModal
  }

  private get fields(): Array<string|any> {
    return [
      { key: 'code', label: 'CODE' },
      { key: 'customer.name', label: 'CUSTOMER NAME' },
      { key: 'totalAmount', class: 'text-right', label: 'TOTAL', formatter: formatters.decimal },
      { key: 'lastUpdated', class: 'text-center', label: 'LAST UPDATED', formatter: formatters.relativeDateTime },
      { key: 'actions', label: 'ACTIONS' },
    ]
  }

  public mounted() {
    this.fetchReceipts()
  }

  private edit(receipt: Receipt) {
    this.editingModal.edit(receipt)
  }

  private async onModalCommitted(receipt: Receipt) {
    // pass
  }
}
